import React, { useEffect, useState, useRef } from 'react';
import { Chart, registerables } from 'chart.js';
import 'chartjs-plugin-annotation';
import { useAuthToken } from "../TokenContext";
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

Chart.register(...registerables);

const DashboardTaskmetricsTalent = ({  podid,selectedSprint,sprintStartDate,sprintEndDate  }) => {
  const token = useAuthToken();
  const intl = useIntl();
  const { user } = useSelector((state) => state.auth);

  const [metrics, setMetrics] = useState(null);
  const chartRef = useRef(null);
  const chartId = useRef(`completedChart-${crypto.randomUUID()}`).current;

  useEffect(() => {
    fetchMetrics();
  }, [podid, token, selectedSprint]);

  useEffect(() => {
    if (metrics) {
      const chartData = [metrics.Complete, metrics.Open];
      displayChart(chartData);
    }

    return () => {
      // Cleanup chart instance on component unmount or before re-rendering
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, [metrics]);

  const fetchMetrics = async () => {
    if (!token) return; // Exit early if there is no token

    try {
      const response = await fetch(process.env.REACT_APP_TALENT_PODTASKSDASHBOARDTALENT, {
        method: 'POST',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            talent_id: user.data[0].c_id,
          pod_id: podid ||[],
          
        }),
      });

      const responseData = await response.json();
      const parsedData = responseData.body; // Assuming responseData.body is already parsed

      if (parsedData && parsedData.Open !== undefined && parsedData.Complete !== undefined) {
        setMetrics(parsedData);
      } else {
        setMetrics(null);
      }
    } catch (error) {
      console.error('Error fetching metrics:', error);
      setMetrics(null);
    }
  };

  const displayChart = (chartData) => {
    const ctx = document.getElementById(chartId);
    if (!ctx) return;

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    chartRef.current = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: ['Completed Tasks', 'Open Tasks'],
        datasets: [
          {
            data: chartData,
            backgroundColor: ['lightgreen', 'red'],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            annotation: {},
            legend: {
                display: false,
            },
        },
        tooltips: {
            enabled: true,
            mode: 'single',
        },
    },
    });
    
    
    
  };

  return (
    <div className="chart-container">
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h2 className="chart-heading">Tasks</h2>
        <br/>
        <div className="chart-wrapper"  style={{marginTop:"20px", width:"135px", height:"135px"}} >
          {metrics && (metrics.Open !== 0 || metrics.Complete !== 0) ? (
            <canvas  id={chartId}    ></canvas>
          ) : (
            <p>{intl.formatMessage({ id: 'noDataAvailable' })}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardTaskmetricsTalent;
